
import MaterialTypes from '../../MaterialTypes';

const standard = new THREE.MeshStandardMaterial({
  side: THREE.DoubleSide,
  roughness: 0.47,
  metalness: 0.0
});

const colors = [
  new THREE.Color(0x333333)
];

export default class EMFMesh extends THREE.Mesh {
  constructor (geom, material = null) {
    const materials = {};

    if (material === null) {
      material = materials[MaterialTypes.NORMAL] = standard;
    } else {
      materials[MaterialTypes.NORMAL] = material;
    }

    materials[MaterialTypes.GHOST] = new THREE.MeshBasicMaterial({
      color: colors[0],
      transparent: true,
      opacity: 0.5,
      depthTest: false,
      depthWrite: false,
      alphaTest: false
      /*
      side: THREE.DoubleSide,
      blending: THREE.CustomBlending,
      blendEquation: THREE.AddEquation,
      blendSrc: THREE.SrcAlphaFactor,
      blendDst: THREE.OneMinusSrcAlphaFactor
      */
    });

    materials[MaterialTypes.TRANSPARENT] = new THREE.MeshBasicMaterial({
      opacity: 0,
      transparent: true,
      depthTest: false,
      depthWrite: false,
      alphaTest: false
    });

    super(
      geom,
      material
    );

    this.materials = materials;
    this.computeUvs();
  }

  setMaterial (type, index = 0) {
    this.material = this.materials[type];
    switch (type) {
      case MaterialTypes.GHOST:
        this.material.color = colors[index % colors.length];
        break;
    }
  }

  setTextures (pack) {
    this.materials[MaterialTypes.NORMAL].map = pack.map;
    this.materials[MaterialTypes.NORMAL].roughnessMap = pack.roughnessMap;
    this.materials[MaterialTypes.NORMAL].normalMap = pack.normalMap;
  }

  computeUvs () {
    let center = new THREE.Vector3();

    this.geometry.computeBoundingBox();
    this.geometry.boundingBox.getCenter(center);

    let right = new THREE.Vector3(1, 0, 0);
    let up = new THREE.Vector3(0, 1, 0);

    this.geometry.faceVertexUvs[0] = this.geometry.faces.map((face, i) => {
      let va = this.geometry.vertices[face.a];
      let vb = this.geometry.vertices[face.b];
      let vc = this.geometry.vertices[face.c];
      let pa = va.clone().projectOnPlane(face.normal);
      let pb = vb.clone().projectOnPlane(face.normal);
      let pc = vc.clone().projectOnPlane(face.normal);

      let axis = right;
      if (Math.abs(face.normal.dot(right)) >= 0.99) {
        axis = up;
      }
      let xAxis = (new THREE.Vector3()).crossVectors(face.normal, axis);
      let yAxis = (new THREE.Vector3()).crossVectors(face.normal, xAxis);

      let uvs = [
        new THREE.Vector2(xAxis.dot(pa) + center.x, yAxis.dot(pa) + center.y),
        new THREE.Vector2(xAxis.dot(pb) + center.x, yAxis.dot(pb) + center.y),
        new THREE.Vector2(xAxis.dot(pc) + center.x, yAxis.dot(pc) + center.y)
      ];

      return uvs;
    });

    this.geometry.uvsNeedUpdate = true;
  }

  highlight () {
    this.setMaterial(MaterialTypes.GHOST);
    // console.log('highlight')
  }

  unhighlight () {
    this.setMaterial(MaterialTypes.NORMAL);
    // console.log('unhighlight')
  }

  hide () {
    this.setMaterial(MaterialTypes.TRANSPARENT);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/geometry/EMFMesh.js